// export const BASEURL = "http://34.138.14.62/ApiReact";
export const BASEURL = "http://servidor.geocontrole.com/ApiReact";